/* External dependencies */
import { applyMiddleware, combineReducers, createStore as createReduxStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import { combineEpics, createEpicMiddleware } from 'redux-observable';

/* Local dependencies */
import { authReducer } from '../components/webApp/modal/auth/redux/reducer';
import { 
  signUpEpic,
  confirmCodeEpic,
  signInEpic,
  forgotPasswordEpic,
  confirmPasswordEpic,
  signOutEpic,
  getSessionEpic,
} from '../components/webApp/modal/auth/redux/epics';

const rootEpic = combineEpics(
  signUpEpic,
  confirmCodeEpic,
  signInEpic,
  forgotPasswordEpic,
  confirmPasswordEpic,
  signOutEpic,
  getSessionEpic,
);


const rootReducer = combineReducers({
 authReducer,
});

let store;        

export function createStore(): Store {
  const epicMiddleware = createEpicMiddleware();
  store = createReduxStore(rootReducer, composeWithDevTools(applyMiddleware(epicMiddleware)));

  epicMiddleware.run(rootEpic);

  return store;
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;